exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___1HVk3 {\n  margin-bottom: 60px;\n  display: flex;\n}\n.loadingContainer___2TWoy {\n  height: 100vh;\n}\n.column___1Ur35 {\n  flex: 1 0 50%;\n}\n.column___1Ur35:first-child {\n  padding-right: 10px;\n}\n@media (min-width: 1200px) {\n  .column___1Ur35:first-child {\n    padding-right: 55px;\n  }\n}\n@media (min-width: 1440px) {\n  .column___1Ur35:first-child {\n    padding-right: 65px;\n  }\n}\n.column___1Ur35:last-child {\n  padding-left: 10px;\n}\n@media (min-width: 1200px) {\n  .column___1Ur35:last-child {\n    padding-left: 55px;\n  }\n}\n@media (min-width: 1440px) {\n  .column___1Ur35:last-child {\n    padding-left: 65px;\n  }\n}\n.title___3RlmZ {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  margin-top: 0;\n}\n.fieldMarginBottom___13fuT {\n  margin-bottom: 20px;\n}\n.img___2Uks9 {\n  width: 100%;\n}\n.back___2aDWK {\n  display: block;\n  margin-top: 20px;\n}\n.attireFieldGroup___uTryn > label {\n  width: 100%;\n}\n.attireFieldGroup___uTryn .label__text {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___1HVk3",
	"loadingContainer": "loadingContainer___2TWoy",
	"column": "column___1Ur35",
	"title": "title___3RlmZ",
	"fieldMarginBottom": "fieldMarginBottom___13fuT",
	"img": "img___2Uks9",
	"back": "back___2aDWK",
	"attireFieldGroup": "attireFieldGroup___uTryn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ZoomEdit/zoomEdit.module.less
// module id = 2327
// module chunks = 71